import { render, staticRenderFns } from "./FooterButtonBuy.vue?vue&type=template&id=ac8980fc&scoped=true"
import script from "./FooterButtonBuy.vue?vue&type=script&lang=js"
export * from "./FooterButtonBuy.vue?vue&type=script&lang=js"
import style0 from "./FooterButtonBuy.vue?vue&type=style&index=0&id=ac8980fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8980fc",
  null
  
)

export default component.exports